import type { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const cmpVisibleSchema: Schema = {
  ...createSchema({
    version: '1-0-0',
    description: 'The CMP consent banner was shown to the user, before any consent decision',
    name: 'cmp_visible',
    properties: {},
  }),
};
